import { ConfigByClient, ConfigByTenant } from "resbutler-utils/types";

// let configuration: ConfigByClient | ConfigByTenant = null;

export function initUI(config: ConfigByClient | ConfigByTenant) {
  // configuration = config;
}

export function getConfigUI(): ConfigByClient | ConfigByTenant {
  const dataUnserialized = window.localStorage.getItem("butler:data");
  return (dataUnserialized ? { ...JSON.parse(dataUnserialized) } : null) as ConfigByClient;
}
